import { render } from "./editQcm.vue?vue&type=template&id=3f6804b2"
import script from "./editQcm.vue?vue&type=script&lang=js"
export * from "./editQcm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__